import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import AdminLayout from './views/Layout/AdminLayout'
import LoginPage from './views/Auth/LoginPage'
import DashboardPage from './views/Dashboard/DashboardPage'
import UserListPage from './views/Users/UserListPage'
import UserDetailPage from './views/Users/UserDetailPage'
import QRCodePage from './views/QRCode/QRCodePage'
import ResourceListPage from './views/Resources/ResourceListPage'
import DiscussionListPage from './views/Discussions/DiscussionListPage'
import ReportListPage from './views/Reports/ReportListPage'
import AdminListPage from './views/Admins/AdminListPage'
import CommunityLinkListPage from './views/CommunityLinks/CommunityLinkListPage'
import AnalyticsPage from './views/Analytics/AnalyticsPage'
import SurveyListPage from './views/Surveys/SurveyListPage'
import CareerCategoryListPage from './views/CareerCategories/CareerCategoryListPage'

// Protected Route Component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, admin, loading } = useAuthStore()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user || !admin) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

// Admin Management Route (super_admin, admin, and senior_assistant)
function AdminManagementRoute({ children }: { children: React.ReactNode }) {
  const { admin } = useAuthStore()
  const allowedRoles = ['super_admin', 'admin', 'senior_assistant']

  if (!admin?.role || !allowedRoles.includes(admin.role)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users" element={<UserListPage />} />
        <Route path="users/:userId" element={<UserDetailPage />} />
        <Route path="qr-codes" element={<QRCodePage />} />
        <Route path="resources" element={<ResourceListPage />} />
        <Route path="discussions" element={<DiscussionListPage />} />
        <Route path="reports" element={<ReportListPage />} />
        <Route path="community-links" element={<CommunityLinkListPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="surveys" element={<SurveyListPage />} />
        <Route path="career-categories" element={<CareerCategoryListPage />} />
        <Route
          path="admins"
          element={
            <AdminManagementRoute>
              <AdminListPage />
            </AdminManagementRoute>
          }
        />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
